import React from 'react';
import EnglishQuestionList from '../VendorAdmin/EnglishQuestionList';

const GlobalEnglishQuestions = () => <EnglishQuestionList globalBankMode />;

export default GlobalEnglishQuestions;
